import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
interface TimerProps {
  isRunning: boolean;
  startTime: number;
}
export function Timer({
  isRunning,
  startTime
}: TimerProps) {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    let interval: number;
    if (isRunning) {
      interval = window.setInterval(() => {
        setElapsed(Date.now() - startTime);
      }, 100);
    }
    return () => clearInterval(interval);
  }, [isRunning, startTime]);
  const formatTime = (ms: number) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };
  return <div className="flex items-center space-x-2 text-slate-700 font-mono text-2xl font-semibold" data-id="element-224">
      <Clock className="w-5 h-5" data-id="element-225" />
      <span data-id="element-226">{formatTime(elapsed)}</span>
    </div>;
}